"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VALUE_PLACEHOLDER = '{V}';
exports.CURRENCY_CODE_PLACEHOLDER = '{S}';
var getPrefixSpacedFormat = function (symbol) { return symbol + " " + exports.VALUE_PLACEHOLDER; };
var getPrefixFormat = function (symbol) { return "" + symbol + exports.VALUE_PLACEHOLDER; };
var getPostfixSpacedFormat = function (symbol) { return exports.VALUE_PLACEHOLDER + " " + symbol; };
exports.defaultCurrencyFormatConfig = {
    format: exports.CURRENCY_CODE_PLACEHOLDER + " " + exports.VALUE_PLACEHOLDER,
    decimalDigits: 2
};
exports.currencyFormatConfig = {
    USD: { format: getPrefixFormat('$'), decimalDigits: 2 },
    EUR: { format: getPrefixFormat('€'), decimalDigits: 2 },
    GBP: { format: getPrefixFormat('£'), decimalDigits: 2 },
    JPY: { format: getPrefixFormat('¥'), decimalDigits: 0 },
    AUD: { format: getPrefixFormat('$'), decimalDigits: 2 },
    BRL: { format: getPrefixFormat('R$'), decimalDigits: 2 },
    CAD: { format: getPrefixFormat('$'), decimalDigits: 2 },
    DKK: { format: getPostfixSpacedFormat('kr'), decimalDigits: 2 },
    HKD: { format: getPrefixFormat('$'), decimalDigits: 2 },
    HUF: { format: getPrefixFormat('Ft'), decimalDigits: 2 },
    MYR: { format: getPrefixFormat('RM'), decimalDigits: 2 },
    MXN: { format: getPrefixFormat('$'), decimalDigits: 2 },
    TWD: { format: getPrefixFormat('NT$'), decimalDigits: 2 },
    NZD: { format: getPrefixFormat('$'), decimalDigits: 2 },
    NOK: { format: getPostfixSpacedFormat('kr'), decimalDigits: 2 },
    SGD: { format: getPrefixFormat('$'), decimalDigits: 2 },
    SEK: { format: getPostfixSpacedFormat('kr'), decimalDigits: 2 },
    CHF: { format: getPrefixFormat('CHF'), decimalDigits: 2 },
    RUB: { format: getPrefixSpacedFormat('руб.'), decimalDigits: 2 }
};
